// Abre/fecha com transição suave: anima grid-template-rows (0fr ↔ 1fr), que
// acompanha a altura real do conteúdo, junto com um fade. Margens/espaços vão
// DENTRO do conteúdo (innerClassName/innerStyle) para fecharem junto;
// `closedClassName` compensa gaps do pai quando fechado.
export default function Collapse({
    open, className = "", openClassName = "", closedClassName = "",
    innerClassName = "", innerStyle, children,
}) {
    return (
        <div
            aria-hidden={!open}
            className={`grid transition-all duration-300 ease-out ${open
                ? `grid-rows-[1fr] opacity-100 ${openClassName}`
                : `grid-rows-[0fr] opacity-0 pointer-events-none ${closedClassName}`} ${className}`}
        >
            {/* O padding NÃO pode ficar no elemento que encolhe (ele não fica
                menor que o próprio padding): vai num filho, cortado pelo overflow. */}
            <div className="min-h-0 overflow-hidden">
                <div className={innerClassName} style={innerStyle}>{children}</div>
            </div>
        </div>
    );
}
